import { getStoryFromGlobalStoryblokStoriesBySlug } from "../utils/global-story-functions";
import { useGlobalStoryblokStories } from "../utils/with-global-story";

export const useGeneralSettings = () => {
  const globalStoryblokStories = useGlobalStoryblokStories();
  const generalSettings = getStoryFromGlobalStoryblokStoriesBySlug(
    "shared-content/settings/general",
    globalStoryblokStories,
  );
  return generalSettings;
};
